/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForActivityLogOci extends models.GovernanceConfigurationBaseForActivityLog {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForActivityLogOci");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForActivityLogOci.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForActivityLogOci>): GovernanceConfigurationForActivityLogOci {
        let obj = Object.assign(new GovernanceConfigurationForActivityLogOci(), model);
        GovernanceConfigurationForActivityLogOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForActivityLogOci>): GovernanceConfigurationForActivityLogOci {
        if (!model) return null;
        return GovernanceConfigurationForActivityLogOci.newInstance(<GovernanceConfigurationForActivityLogOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForActivityLogOci) {
        if (!obj) return;

        models.GovernanceConfigurationForActivityLogOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForActivityLogOci): boolean {
        if (models.GovernanceConfigurationBaseForActivityLog.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForActivityLogOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Region Id
     */
    region: string;

    /**
     * Service Connector Name
     */
    service_connector_name: string;

    /**
     * Topic Name
     */
    topic_name: string;

}
